import { BITCOIN_APP_CONFIG } from "../../config/api";
import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../loader.service";
var BitcoinAppService = /** @class */ (function () {
    function BitcoinAppService(http, loaderService) {
        this.http = http;
        this.loaderService = loaderService;
        this.config = BITCOIN_APP_CONFIG;
        this.iframeVisibility = new BehaviorSubject(null);
        this.updateBalance = new BehaviorSubject(null);
    }
    BitcoinAppService.prototype.getCheckoutUrl = function (aiStyleId, amount, aiTypeImageGeneration, keywords) {
        this.loaderService.show();
        return this.http.post(this.config.getCheckoutUrl, { aiStyleId: aiStyleId, amount: amount, aiTypeImageGeneration: aiTypeImageGeneration, keywords: keywords });
    };
    BitcoinAppService.prototype.getWithdrawUrl = function (amount) {
        this.loaderService.show();
        return this.http.post(this.config.getWithdrawUrl, { amount: amount });
    };
    BitcoinAppService.prototype.isWithdrawCryptoSessionExist = function () {
        this.loaderService.show();
        return this.http.post(this.config.isWithdrawCryptoSessionExist, {});
    };
    BitcoinAppService.prototype.isCheckoutCryptoSessionExist = function () {
        this.loaderService.show();
        return this.http.post(this.config.isCheckoutCryptoSessionExist, {});
    };
    BitcoinAppService.prototype.hideIframe = function () {
        this.iframeVisibility.next({ show: false, src: '' });
    };
    BitcoinAppService.prototype.showIframe = function (src) {
        this.iframeVisibility.next({ show: true, src: src });
    };
    BitcoinAppService.prototype.requestBalanceUpdating = function () {
        this.updateBalance.next(Math.random());
        this.updateBalance.next(null);
    };
    BitcoinAppService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BitcoinAppService_Factory() { return new BitcoinAppService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoaderService)); }, token: BitcoinAppService, providedIn: "root" });
    return BitcoinAppService;
}());
export { BitcoinAppService };
